import type EmailSignatureImagesUploader from '@components/EmailSignaturev2/EmailSignatureEdit/EmailSignatureImagesUploader';
import type { EmailSignatureV2 } from '@components/EmailSignaturev2/types';
import type { EmailSignaturesActions } from '@reducers/email-signature-reducer';

export interface CommonOnboardingDetailsPageForMobileProps {
  emailSignature: EmailSignatureV2;
  emailSignatureDispatch: (action: EmailSignaturesActions) => void;
  handleSave: (
    emailSiganture: EmailSignatureV2,
    onComplete: (savedEmailSignature: EmailSignatureV2) => void,
  ) => Promise<void>;
  uploadEmailSignatureFieldImagesThunk: (
    uploadImage: (emailSignatureImagesUploader: EmailSignatureImagesUploader) => void,
  ) => void;
  handleErrorUploadingImage: () => void;
}

export enum MobileDetailsSteps {
  NAME_DETAILS = 'details',
  OCCUPATION_DETAILS = 'occupation-details',
  CONTACT_DETAILS = 'contact-details',
  SOCIAL_LINKS = 'social-links',
  PREVIEW = 'preview',
  SIGN_UP = 'sign-up',
  CLIENTS = 'clients',
  SET_UP = 'set-up',
}

export interface StepInfo {
  normalizedStep: MobileDetailsSteps;
  stepNumber: number;
}
